import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
export default function Left({ q, setq, setcontinent }) {
  return (
    <div
      style={{
        transition: "all .5s ease-in-out ",
        width: q === true ? "20%" : "0",
        height: "100%",
        background: "#1f4755ff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        alignItems: "center",
      }}
    >
      <Link to={"/continent"} style={{ width: "50%" }}>
        <Button
          variant="contained"
          color="blcak"
          style={{
            height: "100%",
            width: "100%",
            background: "#231919ab",
            color: "whitesmoke",
            display: q ? "flex" : "none",
          }}
          onClick={() => {
            setcontinent("Asia");
          }}
        >
          اسيا
        </Button>
      </Link>
      <Link to={"/continent"} style={{ width: "50%" }}>
        <Button
          variant="contained"
          color="blcak"
          style={{
            height: "100%",
            width: "100%",
            background: "#231919ab",
            color: "whitesmoke",
            display: q ? "flex" : "none",
          }}
          onClick={() => {
            setcontinent("Africa");
          }}
        >
          افريقيا
        </Button>
      </Link>
      <Link to={"/continent"} style={{ width: "50%" }}>
        <Button
          variant="contained"
          color="blcak"
          style={{
            height: "100%",
            width: "100%",
            background: "#231919ab",
            color: "whitesmoke",
            display: q ? "flex" : "none",
          }}
          onClick={() => {
            setcontinent("Europe");
          }}
        >
          اوروبا
        </Button>
      </Link>
      <Link to={"/continent"} style={{ width: "50%" }}>
        <Button
          variant="contained"
          color="blcak"
          style={{
            height: "100%",
            width: "100%",
            background: "#231919ab",
            color: "whitesmoke",
            display: q ? "flex" : "none",
          }}
          onClick={() => {
            setcontinent("North America");
          }}
        >
          امريكا الشمالية
        </Button>
      </Link>
      <Link to={"/continent"} style={{ width: "50%" }}>
        <Button
          variant="contained"
          color="blcak"
          style={{
            height: "100%",
            width: "100%",
            background: "#231919ab",
            color: "whitesmoke",
            display: q ? "flex" : "none",
          }}
          onClick={() => {
            setcontinent("South America");
          }}
        >
          امريكا الجنوبية
        </Button>
      </Link>
      <Link to="/continent" style={{ width: "50%" }}>
        <Button
          variant="contained"
          color="blcak"
          style={{
            height: "100%",
            width: "100%",
            background: "#231919ab",
            color: "whitesmoke",
            display: q ? "flex" : "none",
          }}
          onClick={() => {
            setcontinent("Australia");
          }}
        >
          استراليا
        </Button>
      </Link>
    </div>
  );
}
